import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IChartHistoryData } from './fi-chart-history';

@Component({
    selector: 'fi-chart-history',
    templateUrl: './fi-chart-history.component.html',
    styleUrls: ['./fi-chart-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-chart-history' },
    standalone: false,
})
export class FiChartHistoryComponent {
    @Input() historyItems: IChartHistoryData[] = [];
}
